export default class MobileNav {

    constructor() {
        this.self = $(".mobile-nav");
        this.navItems = this.self.find('.nav-item');
        this.primarys = this.navItems.find('.nav-item-front');
        this.close = this.self.find('.nav-item-back .back');
        this.secondaryLinks = this.self.find('.secondary-links');
        this.scrollTop = $(window).scrollTop();
        this.setEventListeners();
    }

    setEventListeners() {
        this.primarys.on('click', (e) => this.showSecondary(e));
        this.close.on('click', () => this.closeSecondary());
    }

    /**
     * Show subnav links
     * @param e
     */
    showSecondary(e) {
        e.preventDefault();
        let parent = $(e.currentTarget).parent();
        let navLinks = parent.find('.secondary-links');
        this.scrollTop = $(window).scrollTop();

        parent.addClass('active');
        $('.mobile-nav-wrapper').addClass('stop');
        navLinks.addClass('active');
    }

    /**
     * Close subnav
     */
    closeSecondary() {
        let t = this;

        t.navItems.removeClass('active');
        $('.mobile-nav-wrapper').removeClass('stop');
        $(window).scrollTop(t.scrollTop);
        setTimeout(() => {
            t.secondaryLinks.removeClass('active');
            $('.nav-item-secondary').scrollTop(0);
        }, 200);
    }

}


// WEBPACK FOOTER //
// ./public/js/MobileNav.js